export default "__VITE_ASSET__CGgx9ykT__"